import { render } from "./ParsedReport.vue?vue&type=template&id=1fe5b2bb&scoped=true"
import script from "./ParsedReport.vue?vue&type=script&lang=js"
export * from "./ParsedReport.vue?vue&type=script&lang=js"

import "./ParsedReport.vue?vue&type=style&index=0&id=1fe5b2bb&lang=css"
import "./ParsedReport.vue?vue&type=style&index=1&id=1fe5b2bb&scoped=true&lang=css"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe5b2bb"]])

export default __exports__